import type { DataGridProps } from '@mui/x-data-grid'
import * as React from 'react'
export {
  Toolbar as GridToolbar,
  QuickFilter,
  QuickFilterControl,
  useGridApiContext,
  useGridSelector,
  gridRowSelectionManagerSelector,
  gridRowsLookupSelector,
} from '@mui/x-data-grid'

/**
 * Lazy-loaded wrapper around MUI DataGrid - it is a heavy dependency, so will not be included in the root bundle
 */
const MuiDataGrid = React.lazy(() =>
  import('@mui/x-data-grid').then((module) => ({ default: module.DataGrid }))
)

export const DataGrid = (props: DataGridProps) => (
  <React.Suspense fallback={null}>
    <MuiDataGrid
      {...props}
      slotProps={{
        baseCheckbox: { size: props.density === 'compact' ? 'small' : undefined },
        ...props.slotProps,
      }}
    />
  </React.Suspense>
)
